import React, {useEffect, useState} from 'react';
import {Form, Input, Modal} from 'antd';
import {updateGroup} from '../api/groupApi';

/**
 * 그룹 기본정보 수정 모달
 * 그룹명과 그룹내용만 수정 가능
 */
const GroupEditModal = ({ open, onCancel, onSuccess, group }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open && group) {
      form.setFieldsValue({
        groupNm: group.groupNm,
        groupDsctn: group.groupDsctn
      });
    }
  }, [open, group, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setSubmitting(true);
      await updateGroup(group.groupId, {
        groupNm: values.groupNm,
        groupDsctn: values.groupDsctn
      });
      onSuccess?.();
      form.resetFields();
    } catch (e) {
      // validation error -> ignore, request error -> console
      if (e?.message) console.warn(e.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel?.();
  };

  return (
    <Modal
      open={open}
      title="그룹 정보 수정"
      onOk={handleOk}
      confirmLoading={submitting}
      okText="저장"
      cancelText="취소"
      onCancel={handleCancel}
      destroyOnClose
    >
      <Form layout="vertical" form={form} preserve={false}>
        <Form.Item
          label="그룹명"
          name="groupNm"
          rules={[{ required: true, message: '그룹명을 입력하세요.' }]}
        >
          <Input placeholder="그룹명" maxLength={100} />
        </Form.Item>
        <Form.Item
          label="그룹내용"
          name="groupDsctn"
          tooltip="선택 입력"
        >
          <Input.TextArea rows={3} maxLength={1000} placeholder="그룹 설명(선택)" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default GroupEditModal;
